import { FC } from 'react';
import { Badge } from '@new/common/ui/Badge/Badge';
import { useProjectsReview } from '../../contexts/ProjectsReviewProvider';
import type { ProjectsReviewFilter } from '../../contexts/ProjectsReviewProvider';

const FILTER_OPTIONS: { label: string; value: ProjectsReviewFilter }[] = [
  { label: 'All', value: '' },
  { label: 'Approved', value: 'approved' },
  { label: 'Not Yet', value: 'notYet' },
  { label: 'Late', value: 'late' },
  { label: 'In Review', value: 'inReview' },
  { label: 'Pending', value: 'pending' },
  { label: 'Claimed by me', value: 'claimedByMe' },
];

export const ProjectsFilters: FC = () => {
  const { filter, setFilter } = useProjectsReview();

  return (
    <div className="flex items-center gap-2 flex-wrap">
      {FILTER_OPTIONS.map(({ label, value }) => (
        <button key={value || 'all'} onClick={() => setFilter(value)} className="cursor-pointer">
          <Badge
            variant={filter === value ? 'orange-solid' : 'white'}
            className="px-3 py-1.5 text-sm"
          >
            {label}
          </Badge>
        </button>
      ))}
    </div>
  );
};
